import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CloseIcon } from "../../icons";
import MonfiMarkIcon from "../../icons/MonfiMarkIcon";

const WelcomeModal = ({ isOpen, onClose, onContinue }) => (
  <Transition.Root show={isOpen} as={Fragment}>
    <Dialog as="div" className="relative z-50 font-outfit" onClose={onClose}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-black/60 backdrop-blur-[3px]" />
      </Transition.Child>

      <div className="fixed inset-0 z-50 overflow-y-auto p-4 sm:p-5">
        <div className="flex min-h-full items-center justify-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:scale-95"
          >
            <Dialog.Panel className="relative w-full max-w-[438px] overflow-visible rounded-[24px] bg-[#EAF8E8] px-6 pb-6 pt-14 shadow-[0_4px_24px_rgba(0,0,0,0.16)] sm:rounded-[16px] sm:py-6 sm:pl-[88px] sm:pr-8 sm:pt-6">
              <div className="absolute left-1/2 top-0 z-10 flex size-[93px] sm:size-[110px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow-[0_4px_16px_rgba(0,0,0,0.08)] sm:left-0 sm:top-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2">
                <MonfiMarkIcon className="h-[53px] w-[54px] sm:h-[62px] sm:w-[62px]" />
              </div>

              <button
                type="button"
                onClick={onClose}
                className="absolute right-4 top-4 rounded-full p-0 custom-transition hover:bg-white/60"
                aria-label="Close"
              >
                <CloseIcon className="text-[#777777]" />
              </button>

              <div className="flex flex-col items-center text-center sm:items-start sm:pt-1 sm:text-left">
                <Dialog.Title className="text-base font-semibold leading-7 text-[#111] sm:pr-8">
                  Hello, welcome to Monfi!
                </Dialog.Title>
                <p className="mt-1 text-xs leading-[22px] text-[#777]">
                  I&apos;m Monfi-AI get your journey started with me, let me guide you
                  through a detailed tour
                </p>
                <button
                  type="button"
                  onClick={onContinue}
                  className="mt-5 w-full rounded-[10px] bg-[#4AB933] py-3 text-sm font-semibold text-white custom-transition hover:opacity-90 sm:mt-3 sm:w-auto sm:rounded-[8px] sm:px-5 sm:py-[9px]"
                >
                  Get started
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition.Root>
);

export default WelcomeModal;
